export function isTesterKycApproved(user) {
  if (!user || user.role !== 'tester') return true;
  return user.kycStatus === 'approved';
}

export function testerKycBlockedMessage(user) {
  if (!user || user.role !== 'tester') return '';
  if (user.kycStatus === 'rejected') {
    return 'Your identity verification was rejected. Resubmit documents in Settings to unlock actions.';
  }
  if (user.kycStatus === 'pending' || !user.kycStatus) {
    return 'Identity verification is pending. Action buttons unlock once your identity is approved.';
  }
  return 'Complete identity verification in Settings to unlock actions.';
}
